import {
  AssociatedContact,
  IAssociatedContact,
} from '@app/models/AssociatedContact'
import { Attachment, IAttachment } from '@app/models/Attachment'
import { List, Record } from 'immutable'

export enum FormSort {
  Most = 0,
  Alphabetical = 1,
}

export interface IForm {
  readonly hasStarred: List<string>
  readonly id: string
  readonly fileId: string
  readonly file: IAttachment
  readonly description: string
  readonly author?: IAssociatedContact
}

const FormRecord = Record({
  author: undefined,
  description: '',
  file: undefined,
  fileId: '',
  hasStarred: List<string>(),
  id: '',
})

export class Form extends FormRecord implements IForm {
  public static fromJS(initialState?: IForm) {
    if (!initialState) {
      return new Form()
    }

    const { hasStarred, file, author, ...rest } = initialState

    return new Form({
      author: author ? AssociatedContact.fromJS(author) : undefined,
      file: file ? Attachment.fromJS(file) : undefined,
      hasStarred: List(hasStarred || []),
      ...rest,
    })
  }

  public readonly hasStarred: List<string>
  public readonly id: string
  public readonly fileId: string
  public readonly file: Attachment
  public readonly description: string
  public readonly author?: AssociatedContact

  constructor(props?: Partial<Form>) {
    props ? super(props) : super()
  }
}
